import type { StatsDebugSearch } from "~/features/player/components/StatsDebugView/statsDebugTypes.ts";

/**
 * Parses the search params of the stats debug routes.
 *
 * Rule: this file imports types, other search parsers, and constant files with no import. The route config imports
 * it outside the code-split component chunk, so any other import ships in the main bundle.
 */
export const parseStatsDebugSearch = (search: Record<string, unknown>): StatsDebugSearch => ({
    view: typeof search.view === "string" ? search.view : undefined,
    scenario: typeof search.scenario === "string" ? search.scenario : undefined,
});
